import React, { createContext, useState, useContext, useEffect } from "react";
import { getDatabase, ref, get, onValue } from "firebase/database";
import { app } from "../firebase/config";
import { useLocation, Navigate } from "react-router-dom";

const MaintenanceContext = createContext();

export const useMaintenanceMode = () => {
  const context = useContext(MaintenanceContext);
  if (!context) {
    throw new Error(
      "useMaintenanceMode must be used within a MaintenanceProvider"
    );
  }
  return context;
};

const ALLOWED_PATHS = ["/", "/admin"];

export const MaintenanceProvider = ({ children }) => {
  const [isMaintenanceMode, setIsMaintenanceMode] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const db = getDatabase(app);
    const maintenanceModeRef = ref(db, "system/maintenanceMode");

    const unsubscribe = onValue(maintenanceModeRef, (snapshot) => {
      if (snapshot.exists()) {
        setIsMaintenanceMode(snapshot.val());
      }
      setIsLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const value = {
    isMaintenanceMode,
    isLoading,
  };

  return (
    <MaintenanceContext.Provider value={value}>
      {children}
    </MaintenanceContext.Provider>
  );
};

export const MaintenanceGuard = ({ children }) => {
  const { isMaintenanceMode, isLoading } = useMaintenanceMode();
  const location = useLocation();

  if (isLoading) {
    return <div></div>;
  }

  if (isMaintenanceMode && !ALLOWED_PATHS.includes(location.pathname)) {
    return (
      <div className="maintenance-mode">
        <div className="maintenance-content">
          <h1>🛠️ Hệ thống đang bảo trì</h1>
          <p>
            Chúng tôi đang nâng cấp hệ thống để mang lại trải nghiệm tốt hơn.
          </p>
          <p>Vui lòng quay lại sau. Xin cảm ơn!</p>
          <button onClick={() => (window.location.href = "/")}>
            Về trang chủ
          </button>
        </div>
      </div>
    );
  }

  return children;
};
